import { render, staticRenderFns } from "./SeniorMembersList.vue?vue&type=template&id=3f0cd8a8&scoped=true"
import script from "./SeniorMembersList.vue?vue&type=script&lang=js"
export * from "./SeniorMembersList.vue?vue&type=script&lang=js"
import style0 from "./SeniorMembersList.vue?vue&type=style&index=0&id=3f0cd8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0cd8a8",
  null
  
)

export default component.exports